var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 2C8.21573 2 1.5 8.71573 1.5 17C1.5 21.9075 3.85666 26.2645 7.5 29.0011V25.25C7.5 21.5221 10.5221 18.5 14.25 18.5H18.75C22.4779 18.5 25.5 21.5221 25.5 25.25V29.0011C29.1433 26.2645 31.5 21.9075 31.5 17C31.5 8.71573 24.7843 2 16.5 2ZM24 29.9933V25.25C24 22.3505 21.6495 20 18.75 20H14.25C11.3505 20 9 22.3505 9 25.25V29.9933C11.2063 31.2695 13.7678 32 16.5 32C19.2322 32 21.7937 31.2695 24 29.9933ZM0 17C0 7.8873 7.3873 0.5 16.5 0.5C25.6127 0.5 33 7.8873 33 17C33 26.1127 25.6127 33.5 16.5 33.5C7.3873 33.5 0 26.1127 0 17ZM15.75 6.5C14.0931 6.5 12.75 7.84315 12.75 9.5V12.5C12.75 14.1569 14.0931 15.5 15.75 15.5H17.25C18.9069 15.5 20.25 14.1569 20.25 12.5V9.5C20.25 7.84315 18.9069 6.5 17.25 6.5H15.75ZM15.75 5C13.2647 5 11.25 7.01472 11.25 9.5V12.5C11.25 14.9853 13.2647 17 15.75 17H17.25C19.7353 17 21.75 14.9853 21.75 12.5V9.5C21.75 7.01472 19.7353 5 17.25 5H15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingParticipants);
export default __webpack_public_path__ + "static/media/Training_participants.97881a0bcff70359f967dd42cef8d08e.svg";
export { ForwardRef as ReactComponent };